import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-full w-full" }

import { inject, ref } from 'vue';
import { validateEmail } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'GatedDownload',
  props: {
    contentId: null
  },
  setup(__props: any) {

const props = __props as { contentId: string }

const FORM_ENDPOINT = '/.rest/api/v1/download';
const contextPath = inject('contextPath');
const siteName = inject('siteName');
const lang = inject('lang');

const notvalid = ref(false);
let loading = false;
const submitted = ref(false);
const success = ref(false);
const captchaSolved = ref(false);

async function submit({ target }) {
    if (loading) {
        return;
    }
    const form: HTMLFormElement = target.tagName.toLowerCase() === 'form' ? target : target.form;
    const formInputs = target.elements;
    for (let i = 0; i < formInputs.length; i++) {
        if (
            (formInputs[i].required && !formInputs[i].value) ||
            (formInputs[i].type === 'email' && validateEmail(formInputs[i].value))
        ) {
            notvalid.value = true;
        }
    }
    if (!notvalid.value) {
        loading = true;
        submitted.value = false;
        const fd: FormData = new FormData(form);
        if (!fd.has('allowBulkEmail')) {
            fd.set('allowBulkEmail', 'off');
        }
        const url = `${contextPath}${FORM_ENDPOINT}/${siteName}/${lang}/${props.contentId}`;

        try {
            const res = await fetch(url, {
                method: 'POST',
                body: fd
            });
            const data = await res.json();
            success.value = data.success;
        } catch (e) {
            success.value = false;
        }

        submitted.value = true;
        loading = false;
    }
}
function onCaptchaSolved(success: boolean) {
    captchaSolved.value = success;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["absolute flex h-full w-full flex-col items-start transition-opacity duration-500", [submitted.value ? 'pointer-events-none opacity-0' : 'opacity-100']])
    }, [
      _renderSlot(_ctx.$slots, "default", {
        captchaSolved: captchaSolved.value,
        onCaptchaSolved: onCaptchaSolved,
        submit: submit,
        notvalid: notvalid.value,
        submitted: submitted.value
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute flex h-full w-full flex-col items-start transition-opacity delay-500 duration-500", [submitted.value && success.value ? 'opacity-100' : 'pointer-events-none opacity-0']])
    }, [
      _renderSlot(_ctx.$slots, "success")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute flex h-full w-full flex-col items-start transition-opacity delay-500 duration-500", [submitted.value && !success.value ? 'opacity-100' : 'pointer-events-none opacity-0']])
    }, [
      _renderSlot(_ctx.$slots, "error")
    ], 2)
  ]))
}
}

})